module.exports = __webpack_public_path__ + "img/ring_g_o_null_1@2x.4b0b5404.png";